import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return {
    footerLogo: {
      position: 'absolute',
      bottom: 10,
      right: 50,
      zIndex: 0,
      padding: theme.spacing(2),
      height: 'auto',
      width: '25vw',
      minWidth: 400,
      maxWidth: 400,
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        left: 0,
        right: 0,
        margin: '0 auto',
        width: '100vw',
      },
      [theme.breakpoints.down(300)]: {
        display: 'none',
      },
      '@media screen and ( max-height: 600px )': {
        display: 'none',
      }
    },
  };
});
